import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {LESSON} from "../../../Config/ApiUrl";
import { formatDateTimeToLocalDate } from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            courseId: this.props.courseId,
            options: {
                name: this.$t('lessons.title'),
                tableShadow: false,
                showHeader: true,
                showSearch: false,
                showFilter: false,
                showCount: false,
                showClearFilter: false,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'text',
                        key: 'title',
                        isVisible: true,
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        name: 'view_details',
                        url: LESSON,
                    }
                ],
            }
        };
    },
    watch: {
        courseId(newCourseId) {
            if (newCourseId) {
                this.updateUrl(newCourseId);
            }
        }
    },
    methods: {
        updateUrl(courseId) {
            if (courseId) {
                this.options.url = `${LESSON}/${courseId}/getCourseLessons`;
            }
        }
    },
    mounted() {
        // Ensure URL is set when component mounts (for initial courseId)
        if (this.courseId) {
            this.updateUrl(this.courseId);
        }
    }
};

export function isImage(url) {
    return /\.(jpeg|jpg|gif|png|svg|webp)$/i.test(url);
}
